// extracted by mini-css-extract-plugin
export var quillEditor = "_og-1";
export var variable = "_og-0";